module.exports = __webpack_public_path__ + "static/media/dropdown_icon.9fe24314.svg";